export enum Methods {
  StakePosition = 'stakePosition',
  UnstakeFromPosition = 'unstakeFromPosition',
  Claim = 'claim',
  StakePositionAnyToken = 'stakePositionAnyToken',
  StakePositionETH = 'stakePositionETH'
}
